import React, { useContext, useRef, useState } from "react";
import {
  ListGroup,
  Dropdown,
  Row,
  Col,
  Card,
  Button,
  Form,
} from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { ConfigContext } from "../../../../contexts/ConfigContext";
import useAuth from "../../../../hooks/useAuth";
import avatar1 from "../../../../assets/images/user/avatar-1.jpg";
import {
  BASE_API_ENDPOINT,
  getRoleName,
  validatePassword,
} from "../../../../config/constant";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axiosServices from "../../../../utils/axios";
import CommonModal from "./../../../../UI/CommonModal";
import useToast from "../../../../hooks/customHook/useToast";
import { FiEdit2 } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
const NavRight = ({ getUserName }) => {
  const configContext = useContext(ConfigContext);
  const { isLoggedIn, logout, user: loggedUser } = useAuth();
  const { rtlLayout } = configContext.state;
  const [lgShow, setLgShow] = useState(false);
  const [cpShow, setCpShow] = useState(false);
  const [updateUserDetail, setUpdateUserDetail] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [userInformation, setUserInformation] = useState({
    userPhoneNumber: "",
    username: "",
  });
  const { username, userPhoneNumber } = userInformation;
  const [passwords, setPasswords] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const { oldPassword, newPassword, confirmPassword } = passwords;
  const [user, setUser] = useState(loggedUser || "");
  const history = useHistory();
  const { successToast, errorToast } = useToast();
  const oldPasswordRef = useRef(null);
  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const usernameRef = useRef(null);
  const phoneNumberRef = useRef(null);
  const [errorPayload, setError] = useState({
    type: null,
    error: "",
  });

  const getUser = async () => {
    try {
      const { data } = await axiosServices.get(`${BASE_API_ENDPOINT}/user/me`);
      if (data) {
        setUser(data.data);
        getUserName(data.data.username);
        setUserInformation((info) => ({
          ...info,
          username: data.data.username,
          userPhoneNumber: data.data.phone_number,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleLogout = () => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: "Logout",
      text: "Are you sure you want to logout?",

      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonColor: "#2d3393",
      confirmButtonText: "Logout",
      confirmButtonColor: "#d9534f",
    }).then((willLogout) => {
      if (willLogout.value) {
        logout();
      }
    });
  };

  const handleLogin = () => {
    history.push("/auth/login");
  };
  const handleProfileClick = () => {
    setLgShow((lgShow) => !lgShow);
  };

  const validParams = (newPassword, oldPassword, confirmPassword) => {
    if (oldPassword.trim().length === 0) {
      setError({
        error: "Old password required !",
        type: "oldPassword",
      });
      oldPasswordRef.current.focus();
      return false;
    } else if (
      newPassword.trim().length === 0 ||
      !validatePassword(newPassword.trim())
    ) {
      setError({
        error:
          "Password must be at least 8 characters, include letters, numbers, and symbols.",
        type: "newPassword",
      });
      newPasswordRef.current.focus();
      return false;
    } else if (confirmPassword.trim() !== newPassword.trim()) {
      setError({
        error: "New Password & Confirm Password must match!",
        type: "confirmPassword",
      });
      confirmPasswordRef.current.focus();
      return false;
    } else return true;
  };

  const validUserInfo = (username, userPhoneNumber) => {
    if (userPhoneNumber.toString().trim().length !== 10) {
      setError({
        error: "Phone number required !",
        type: "phoneNumber",
      });
      phoneNumberRef.current.focus();
      return false;
    } else if (username.trim().length === 0) {
      setError({
        error: "Username required !",
        type: "username",
      });
      usernameRef.current.focus();
      return false;
    } else return true;
  };

  const handleOnSubmit = async () => {
    if (cpShow) {
      if (validParams(newPassword, oldPassword, confirmPassword)) {
        let body = {
          newPassword,
          oldPassword,
        };
        setButtonDisable(true);

        try {
          const { data } = await axiosServices.patch(
            `${BASE_API_ENDPOINT}/user/change-password`,
            body,
          );

          if (data.status === "OK") {
            successToast("Password changed successfully !");
            reset();
          } else {
            throw new Error("Something went wrong");
          }
        } catch (error) {
          errorToast(error?.message || "Something went wrong");
          setError({
            error: error?.message || "Something went wrong",
            type: "apiError",
          });
          console.log(error);
        } finally {
          setButtonDisable(false);
        }
      }
      return false;
    } else if (lgShow) {
      // allow update to Admin only
      if (loggedUser["user_role"] !== "1")
        throw new Error("User not authorized to update information.");

      if (validUserInfo(username, userPhoneNumber)) {
        let body = {
          userPhoneNumber,
          username,
        };
        setButtonDisable(true);

        try {
          const { data } = await axiosServices.patch(
            `${BASE_API_ENDPOINT}/user/update-profile`,
            body,
          );

          if (data.status === "OK") {
            successToast("User detail updated successfully !");
            reset();
            getUser();
          } else {
            throw new Error("Something went wrong");
          }
        } catch (error) {
          errorToast(error?.message || "Something went wrong");
          setError({
            error: error?.message || "Something went wrong",
            type: "apiError",
          });
          console.log(error);
        } finally {
          setButtonDisable(false);
        }
      }
    }
  };

  const handleUpdateUserToggle = () => {
    setUpdateUserDetail(true);
    setUserInformation((info) => ({
      ...info,
      username: user?.username || "",
      userPhoneNumber: user.phone_number || "",
    }));
  };

  const handleUpdateUserToggleClose = () => {
    setUserInformation((info) => ({
      ...info,
      username: "",
      userPhoneNumber: "",
    }));
    setUpdateUserDetail(false);
    reset();
  };

  const content = (
    <React.Fragment>
      <div className="profileContainer navright-profile-head">
        <Row>
          <Col sm={12}>
            <Card className="m-0">
              <Card.Header className="d-flex justify-between flex-align-center">
                <Card.Title as="h5">
                  {updateUserDetail ? "Update User Detail" : "User Detail"}
                </Card.Title>
                {loggedUser["user_role"] === "1" && (
                  <span title="Update user details">
                    <FiEdit2
                      className="hover-cursor"
                      onClick={handleUpdateUserToggle}
                    />
                  </span>
                )}
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col lg={12}>
                    <Form>
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>Username {}</Form.Label>

                        <Form.Control
                          value={
                            updateUserDetail ? username : user.username || ""
                          }
                          onChange={(e) => {
                            setUserInformation((userInformation) => ({
                              ...userInformation,
                              username: e.target.value,
                            }));
                            setError({
                              type: null,
                              error: "",
                            });
                          }}
                          type="text"
                          disabled={!updateUserDetail}
                          placeholder="Enter Name"
                          ref={usernameRef}
                        />
                        <span className="error-span">
                          {errorPayload.type === "username" &&
                            errorPayload.error}
                        </span>
                      </Form.Group>
                      <Form.Group controlId="exampleForm.ControlInput2">
                        <Form.Label>Phone Number</Form.Label>

                        <Form.Control
                          value={
                            updateUserDetail
                              ? userPhoneNumber
                              : user.phone_number
                          }
                          onChange={(e) => {
                            const re = /^[0-9\b]+$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              setUserInformation((userInformation) => ({
                                ...userInformation,
                                userPhoneNumber: e.target.value,
                              }));
                            }
                            setError({
                              type: null,
                              error: "",
                            });
                          }}
                          type="text"
                          maxLength={10}
                          disabled={!updateUserDetail}
                          placeholder="Enter Phone Number"
                          ref={phoneNumberRef}
                        />
                        <span className="error-span">
                          {errorPayload.type === "phoneNumber" &&
                            errorPayload.error}
                        </span>
                      </Form.Group>

                      {/* <Button varient="primary" onClick={()=>closeModal(false)}>Close</Button> */}
                      <Form.Group controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          value={user.email || ""}
                          disabled={true}
                          type="email"
                          placeholder="Enter Email"
                        />
                        <Form.Text className="text-muted">
                          {/* We'll never share your email with anyone else. */}
                        </Form.Text>
                      </Form.Group>
                    </Form>
                  </Col>
                  <div className="err-div">
                    <span className="error-span">
                      {errorPayload.type === "apiError" && errorPayload.error}
                    </span>
                  </div>
                </Row>
              </Card.Body>

              <Card.Footer
                className={
                  updateUserDetail && loggedUser["user_role"] === "1"
                    ? ""
                    : "is-hidden"
                }
              >
                <div className="txt-center">
                  {buttonDisable ? (
                    <Button>
                      <span
                        size="sm"
                        className="spinner-border spinner-border-sm mr-1"
                        role="status"
                      />
                      Submitting...
                    </Button>
                  ) : (
                    <>
                      <Button
                        onClick={handleUpdateUserToggleClose}
                        variant="secondary"
                        // disabled={userDetail}
                      >
                        Cancel
                      </Button>
                      <Button
                        onClick={handleOnSubmit}
                        variant="primary"
                        // disabled={userDetail}
                      >
                        Update
                      </Button>
                    </>
                  )}
                </div>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );

  const cpContent = (
    <React.Fragment>
      <div className="profileContainer navright-profile-head">
        <Row>
          <Col sm={12}>
            <Card className="m-0">
              <Card.Header className="d-flex justify-between flex-align-center">
                <Card.Title as="h5">Change Password</Card.Title>
                <span title="Update user details">
                  <IoMdClose className="hover-cursor" onClick={() => reset()} />
                </span>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col lg={12}>
                    <Form>
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>Old Password</Form.Label>

                        <Form.Control
                          value={oldPassword}
                          onChange={(e) => {
                            setPasswords((passwords) => ({
                              ...passwords,
                              oldPassword: e.target.value,
                            }));
                            setError({
                              type: null,
                              error: "",
                            });
                          }}
                          type="password"
                          disabled={updateUserDetail}
                          placeholder="Enter Old Password"
                          ref={oldPasswordRef}
                        />
                        <span className="error-span">
                          {errorPayload.type === "oldPassword" &&
                            errorPayload.error}
                        </span>
                      </Form.Group>
                      <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>New Password</Form.Label>

                        <Form.Control
                          value={newPassword || ""}
                          onChange={(e) => {
                            setPasswords((passwords) => ({
                              ...passwords,
                              newPassword: e.target.value,
                            }));
                            setError({
                              type: null,
                              error: "",
                            });
                          }}
                          type="password"
                          disabled={updateUserDetail}
                          placeholder="Enter New Password"
                          ref={newPasswordRef}
                        />
                        <span className="error-span">
                          {errorPayload.type === "newPassword" &&
                            errorPayload.error}
                        </span>
                        {/* {isUserError && (
                    )} */}
                      </Form.Group>

                      {/* <Button varient="primary" onClick={()=>closeModal(false)}>Close</Button> */}
                      <Form.Group controlId="formBasicEmail">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                          value={confirmPassword || ""}
                          onChange={(e) => {
                            setPasswords((passwords) => ({
                              ...passwords,
                              confirmPassword: e.target.value,
                            }));
                            setError({
                              type: null,
                              error: "",
                            });
                          }}
                          type="password"
                          disabled={updateUserDetail}
                          placeholder="Confirm New Password"
                          ref={confirmPasswordRef}
                        />
                        <span className="error-span">
                          {errorPayload.type === "confirmPassword" &&
                            errorPayload.error}
                        </span>
                        {/* {isMailError && (
                  )} */}
                      </Form.Group>
                    </Form>
                    <div className="txt-center">
                      <span className="error-span">
                        {errorPayload.type === "apiError" && errorPayload.error}
                      </span>
                    </div>
                  </Col>
                </Row>
              </Card.Body>

              <Card.Footer className={cpShow || lgShow ? "" : "is-hidden"}>
                <div className="txt-center">
                  {buttonDisable ? (
                    <Button>
                      <span
                        size="sm"
                        className="spinner-border spinner-border-sm mr-1"
                        role="status"
                      />
                      Submitting...
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {
                        handleOnSubmit();
                      }}
                      variant="primary"
                      disabled={
                        !oldPassword || !newPassword || !confirmPassword
                      }
                    >
                      {cpShow ? "Change Password" : "Update User-Detail"}
                    </Button>
                  )}
                </div>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );

  const reset = () => {
    setLgShow(false);
    setCpShow(false);
    setUserInformation((info) => ({
      ...info,
      username: "",
      userPhoneNumber: "",
    }));
    setUpdateUserDetail(false);
    setError({
      type: null,
      error: "",
    });
    setPasswords({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
    setButtonDisable(false);
  };

  return (
    <React.Fragment>
      <ListGroup
        as="ul"
        bsPrefix=" "
        id="navbar-right"
        className="navbar-nav ml-auto d-flex justify-content-between align-items-center nav-row"
      >
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown alignRight={!rtlLayout} className="drp-user">
            <Dropdown.Toggle
              as={Link}
              variant="link"
              to="#"
              id="dropdown-basic"
            >
              <i className="icon feather icon-user" />
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight className="profile-notification">
              <div className="pro-head d-flex flex-row bd-highlight mb-3">
                <div>
                  <img
                    src={avatar1}
                    className="img-radius"
                    alt="User Profile"
                  />
                </div>

                <div>
                  <span>{`${user.username}`}</span>
                  <br />

                  <span>{getRoleName(Number(user.user_role))} </span>
                </div>
              </div>

              <ListGroup
                as="ul"
                bsPrefix=" "
                variant="flush"
                className="pro-body pt-0"
              >
                <ListGroup.Item
                  as="li"
                  bsPrefix=" "
                  onClick={handleProfileClick}
                >
                  <Link to="#" className="dropdown-item">
                    <i className="feather icon-user" /> Profile
                  </Link>
                </ListGroup.Item>

                <ListGroup.Item
                  as="li"
                  bsPrefix=" "
                  onClick={() => setCpShow(!cpShow)}
                >
                  <Link to="#" className="dropdown-item">
                    <i className="feather icon-lock" /> Change Password
                  </Link>
                </ListGroup.Item>

                {isLoggedIn ? (
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={handleLogout}
                    >
                      <i className="feather icon-log-out" /> Logout
                    </Link>
                  </ListGroup.Item>
                ) : (
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={handleLogin}
                    >
                      <i className="feather icon-log-in" /> Login
                    </Link>
                  </ListGroup.Item>
                )}
              </ListGroup>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
      </ListGroup>
      {(cpShow || lgShow) && (
        <CommonModal
          show={lgShow || cpShow}
          handleOnHide={() => {
            reset();
          }}
          title={cpShow ? "Change Password" : "User Detail"}
          content={cpShow ? cpContent : content}
          size={"md"}
        />
      )}
    </React.Fragment>
  );
};

export default NavRight;
